import { useStringForPlaceholders } from "@1js/localization-components";
import type { Group } from "@1js/pl-types";
import {
  Avatar,
  Tag,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import React from "react";
import { PromptWorkgroupLabel } from "./PromptWorkgroup.strings";

export type PromptWorkgroupProps = {
  group: Group;
};

const useStyles = makeStyles({
  WorkgroupName: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "auto",
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    ...shorthands.border("0px"),
    ...shorthands.margin("0px"),
    ...shorthands.padding("0px"),
  },
});

export const PromptWorkgroup: React.FC<PromptWorkgroupProps> = React.memo(
  ({ group }) => {
    const styles = useStyles();

    const groupImage = group.AvatarUrl ? { src: group.AvatarUrl } : undefined;
    const authorLabel = useStringForPlaceholders(PromptWorkgroupLabel);
    const displayName = group.DisplayName;
    const avatar = (
      <Avatar
        image={groupImage}
        name={displayName}
        color={"colorful"}
        shape="square"
        size={20}
        aria-hidden={true}
        data-testid="prompt-workgroup-avatar"
      />
    );
    return (
      <Tag
        tabIndex={0}
        size={"small"}
        media={avatar}
        data-testid="prompt-workgroup-tag"
      >
        <span aria-hidden={true}>{displayName}</span>
        <span className={styles.WorkgroupName}>
          {authorLabel({ workgroupName: displayName })}
        </span>
      </Tag>
    );
  }
);

PromptWorkgroup.displayName = "PromptWorkgroup";
